import axios from "axios";
import React, { useEffect, useRef, useState } from "react"; 
import { toast, Toaster } from "sonner";
 
export default function RecentlyViewed() {
  const videoRefs = useRef([]);
  const [playingVideo, setPlayingVideo] = useState(null);
  const [promoVideos, setPromoVideos] = useState([]);
  const scrollContainerRef = useRef(null);

  const fetchAllPromoVideos = async () => {
    try {
      const response = await axios.get("https://wavetechservices.in/api/admin/promovideo");
      setPromoVideos(response.data.promoVideos); 
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to load videos!");
    }
  };

  useEffect(() => { 
    fetchAllPromoVideos();
  }, []);

  const togglePlay = (index) => {
    if (playingVideo === index) {
      videoRefs.current[index].pause();
      setPlayingVideo(null);
    } else {
      if (playingVideo !== null) {
        videoRefs.current[playingVideo].pause();
      }
      videoRefs.current[index].play()
        .then(() => setPlayingVideo(index))
        .catch(e => console.log("Play failed:", e));
    }
  };

  return (
    <div className="px-4 py-8 bg-gray-50">
      <Toaster/>
      <div className="max-w-7xl mx-auto">
         <div className="text-center mb-12">
            
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">
             Our Most {" "}
              <span className="text-transparent bg-clip-text text-gradient from-blue-500 to-purple-600">
                 Exceptional Experiences
              </span>
            </h1>
          </div>
        {/* <h2 className="text-2xl font-bold mb-6 text-center"></h2>  */}
        
        {/* Scrollable container */}
        <div 
          ref={scrollContainerRef}
          className="relative"
        >
          <div 
            className="flex space-x-4 pb-4 overflow-x-auto scroll-snap"
            style={{ 
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
              scrollSnapType: 'x mandatory',
              WebkitOverflowScrolling: 'touch'
            }}
          >
            {promoVideos?.map((product, index) => (
              <div 
                key={product._id}
                className="flex-shrink-0 rounded-lg overflow-hidden shadow-md bg-white hover:shadow-lg transition-shadow cursor-pointer"
                style={{ 
                  width: '300px',
                  height: '500px',
                  scrollSnapAlign: 'start'
                }}
                onClick={() => togglePlay(index)}
              >
                <div className="relative w-full h-full bg-black">
                  <video
                    ref={el => videoRefs.current[index] = el}
                    className="w-full h-full object-cover" 
                    // muted
                    loop
                    playsInline
                  >
                    <source 
                      src={`${product.image}`}
                      type="video/mp4" 
                    />
                    Your browser does not support the video tag.
                  </video>
                  
                  {playingVideo !== index && (
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="bg-white bg-opacity-80 rounded-full p-3">
                        <svg className="w-8 h-8 text-gray-800" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M6.3 2.841A1.5 1.5 0 004 4.11v11.78a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z"/>
                        </svg>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Hide scrollbar globally */}
      <style jsx global>{`
        ::-webkit-scrollbar {
          display: none;
        }
        .scroll-snap {
          -webkit-overflow-scrolling: touch;
        }
        .scroll-snap > * {
          scroll-snap-align: start;
        }
      `}</style>
    </div>
  );
}